
import { useState } from "react";

/**
 * Hook for managing job details form state
 */
export const useJobDetails = () => {
  const [jobTitle, setJobTitle] = useState('');
  const [company, setCompany] = useState('');
  const [jobDescription, setJobDescription] = useState('');
  
  const resetJobDetails = () => {
    setJobTitle('');
    setCompany('');
    setJobDescription('');
  };

  return {
    jobTitle,
    company,
    jobDescription,
    setJobTitle,
    setCompany,
    setJobDescription,
    resetJobDetails
  };
};
